import { Plans } from '@/features/plans/components/plans';

export default function PlansPage() {
  return <Plans />;
}
